import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

import { ROUTE_PATHS } from 'models/sideMenu';
import { checkAuthGuard } from 'models/auth';

import AdultCheckupReportInner from './Inner';

const routes: CustomRoute = {
	path: '/adult-checkup-report',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next }) => {
		const children = await next();
		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'adultCheckupReportSelection' */ './component')],
			render: ([AdultCheckupReportSelection]) => <AdultCheckupReportSelection />,
			onEnter: async ({ store, next }) => {
				const allowEnter = checkAuthGuard(store, `/${ROUTE_PATHS.ADULT_CHECKUP_REPORT}`);
				if (!allowEnter) {
					return false;
				}
				const children = await next();
				return children;
			},
		},
		AdultCheckupReportInner,
	],
};

export default routes;
